export default __webpack_public_path__ + "static/discord-86f5772731b544dbf0f3f2b8de26cc92.png";